import { getServiceUrl, httpGet } from '../services/api';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const getUrl = (url) => getServiceUrl('marketing', url);

export async function getJson(json) {
    return httpGet<any>(json);
}
